import { Button, Form, Input, Space, Switch } from "antd";
import { useTranslation } from "react-i18next";
import { Question } from "../../../../hooks/api/survey";

export function QuestionEditor({
  question,
  onChange,
}: {
  question: Question;
  onChange: (patch: Partial<Question>) => void;
}) {
  const { t } = useTranslation();
  const options = question.options ?? [];

  return (
    <Form layout="vertical">
      <Form.Item label={t("pages.survey.title")}>
        <Input
          value={question.title}
          onChange={(e) => onChange({ title: e.target.value })}
        />
      </Form.Item>

      <Form.Item label={t("pages.survey.required")}>
        <Switch
          checked={question.required}
          onChange={(v) => onChange({ required: v })}
        />
      </Form.Item>

      {options && (
        <Form.Item label={t("pages.survey.options")}>
          <Space orientation="vertical" style={{ width: "100%" }}>
            {options.map((opt, idx) => (
              <Space key={idx} style={{ display: "flex" }}>
                <Input
                  placeholder={t("pages.survey.optionValue")}
                  value={opt.value}
                  onChange={(e) => {
                    const next = [...options];
                    next[idx] = { ...opt, value: e.target.value };
                    onChange({ options: next });
                  }}
                />
                <Input
                  placeholder={t("pages.survey.optionLabel")}
                  value={opt.label}
                  onChange={(e) => {
                    const next = [...options];
                    next[idx] = { ...opt, label: e.target.value };
                    onChange({ options: next });
                  }}
                />
                <Button
                  danger
                  onClick={() =>
                    onChange({
                      options: options.filter((_, i) => i !== idx),
                    })
                  }
                  aria-label={t("pages.survey.removeOption")}
                >
                  X
                </Button>
              </Space>
            ))}

            <Button
              type="dashed"
              onClick={() =>
                onChange({
                  options: [...options, { value: "", label: "" }],
                })
              }
            >
              {t("pages.survey.addOption")}
            </Button>
          </Space>
        </Form.Item>
      )}
    </Form>
  );
}
